module.exports = __webpack_public_path__ + "media/images/check_mark-cc8266e86d187f3eda7a4fec53153a2f.gif";